import axios from "axios";

const instance = axios.create({
  baseURL: process.env.REACT_APP_CORE_PATH,
});


instance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers["x-access-token"] = token;
    }
    return config;
  },
  (err) => {
    return Promise.reject(err);
  }
);

instance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true; 
      const accessToken = localStorage.getItem("accessToken");
      const refreshToken = localStorage.getItem("refreshToken");
      if (!refreshToken || !accessToken) {
        return Promise.reject(error);
      }
      const res = await instance.post(
        `/auth/refresh`,
        {}, {
        headers: {
          "x-access-token": accessToken,
          "x-refresh-token": refreshToken,
        },
      }
      );
      if (res.status === 200) {
        localStorage.setItem("accessToken", res.data.accessToken);
        localStorage.setItem("refreshToken", res.data.refreshToken);
        return instance(originalRequest);
      }
    }
    return Promise.reject(error);
  }
);



export default instance;